import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
export const GET_POS_ORDER_LINES_REQUEST = "GET_POS_ORDER_LINES_REQUEST";
export const GET_POS_ORDER_LINES_SUCCESS = "GET_POS_ORDER_LINES_SUCCESS";
export const GET_POS_ORDER_LINES_FAILURE = "GET_POS_ORDER_LINES_FAILURE";

export const getPosOrderLinesRequest = () => ({
  type: GET_POS_ORDER_LINES_REQUEST,
});
export const getPosOrderLinesSuccess = (orderLines) => ({
  type: GET_POS_ORDER_LINES_SUCCESS,
  payload: orderLines,
});
export const getPosOrderLinesFailure = (error) => ({
  type: GET_POS_ORDER_LINES_FAILURE,
  payload: error,
});

// 🔥 Splits a shared available_refund_qty across lines with the same product_id
// (backend returns the aggregated total per product; we allocate it
// proportionally by each line's own qty, so paid vs free lines each get
// their fair share instead of both showing the full combined amount).
const splitSharedRefundQty = (lines) => {
  if (!Array.isArray(lines)) return lines;

  const groups = {};
  lines.forEach((line) => {
    const key = `${line.product_id}_${line.package_id || ""}`;
    if (!groups[key]) groups[key] = [];
    groups[key].push(line);
  });

  return lines.map((line) => {
    const key = `${line.product_id}_${line.package_id || ""}`;
    const group = groups[key];

    if (group.length === 1) {
      return line; // nothing shared, leave as-is
    }

    const totalQtyInGroup = group.reduce((sum, l) => sum + l.qty, 0);
    const sharedAvailable = line.available_refund_qty;

    const proportionalShare = totalQtyInGroup > 0
      ? Math.round((sharedAvailable * line.qty) / totalQtyInGroup)
      : 0;

    return {
      ...line,
      available_refund_qty: Math.min(proportionalShare, line.qty),
    };
  });
};

export const fetchPosOrderLines = (order_id, lang) => async (dispatch, getState) => {
  dispatch(getPosOrderLinesRequest());
  try {
    const state = getState();
    const userId = state?.login?.user?.user_id;

    const response = await axiosInstance.post(URLS.POS_ORDER_LINES, {
      lang,
      order_id,
    });

    console.log("response?.data.result.records", response?.data.result.records);

    if (response?.data.result.records) {
      const correctedRecords = splitSharedRefundQty(response.data.result.records);
      dispatch(getPosOrderLinesSuccess(correctedRecords, userId));
    }
  } catch (error) {
    dispatch(getPosOrderLinesFailure(error));
  }
};